module.exports = __webpack_public_path__ + "static/media/agrandir.6f9173f9.svg";